import React from 'react';
import HeaderBannerContext from '@framework/ui/Organisms/HeaderBanner/HeaderBannerContext';
import CookiesBannerContext from '@framework/cookie-consent/CookiesBannerContext';
import { IGlobalProps } from './../withGlobalProps';
import FeatureToggleContextProvider from '@framework/ui/Organisms/FeatureToggle/Context';

interface IProps extends IGlobalProps {
  children: React.ReactNode,
}

const GlobalProps = ({ children, banner, featuresConfig }: IProps) => (
  <HeaderBannerContext value={ banner }>
    <CookiesBannerContext>
      <FeatureToggleContextProvider featuresConfig={ featuresConfig }>
        { children }
      </FeatureToggleContextProvider>
    </CookiesBannerContext>
  </HeaderBannerContext>
);

export default GlobalProps;
